import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { withStyles } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {},
    summary: {
        display: 'flex',
        width: '100%',
    },
    title: {
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'center',
        height: '48px',
    },
    extra: {
        padding: '0 !important',
        display: 'flex',
        alignItems: 'center',
    },
    details: {
        borderTop: 'solid 1px #eee',
        padding: `${theme.spacing(3)}px`,
    },
    wideDetails: {
        padding: 0,
    },
});

function ExpansionContainer({
    title,
    extra,
    children,
    onChange,
    wide,
    classes,
}) {
    const detailsClassName = classNames(classes.details, {
        [classes.wideDetails]: wide,
    });
    return (
        <ExpansionPanel onChange={(e, opened) => onChange(opened, e)}>
            <ExpansionPanelSummary className={classes.summary}>
                <Typography
                    className={classes.title}
                    variant="h6"
                    color="textSecondary"
                >
                    {title}
                </Typography>
                {extra && <div className={classes.extra}>{extra}</div>}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={detailsClassName}>
                {children}
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
}

ExpansionContainer.propTypes = {
    title: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    extra: PropTypes.node,
    className: PropTypes.string,
    onChange: PropTypes.func,
    wide: PropTypes.bool,
};
ExpansionContainer.defaultProps = {
    onChange: () => {},
    wide: false,
};

export default withStyles(styles)(ExpansionContainer);
